goog.provide('el8.ptdata.visitNote2s');

/**
 * Visit Note 2.0 module. Not implementing via an `el8_Entity` / `el8_EntitySet` because
 * there is barely any use case for interacting with Note 2.0s from legacy; the only reason
 * this file exists is because the legacy toolbar needs to be able to create a Note 2.0.
 * Once that toolbar is Reactified this file can and should be deleted.
 */
el8.ptdata.visitNote2s = {
  create: function createVisitNote2(opts) {
    opts = opts || {};

    var physicianId;
    if (el8.data.currUser.isPhysician()) {
      physicianId = el8.data.currUser.getStaffId();
    } else {
      var defaultPhysicianId = el8.data.currUser.getDefaultPhysicianId();
      if (defaultPhysicianId) {
        physicianId = defaultPhysicianId;
      } else {
        physicianId = el8.data.practiceUsers.getPhysicianUsersInWorkspace()[0].staffId;
      }
    }

    $.el8_ajax({
      url: '/practices/' + el8Globals.PRACTICE_ID + '/notes/',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
          category: el8.data.visitNoteTypes.allAsSoyMaps()[0].id,
          content: {
              type: 'document',
              content: [
                  {
                      type: 'twoColumnLayout',
                      content: [
                          {
                              type: 'columnLayout',
                              content: [
                                  {
                                    type: 'paragraph',
                                    content: []
                                  }
                              ]
                          },
                          {
                              type: 'columnLayout',
                              content: [
                                  {
                                    type: 'paragraph',
                                    content: []
                                  }
                              ]
                          }
                      ]
                  }
              ]
          },
          patient: el8Globals.PATIENT_ID,
          practice: el8Globals.PRACTICE_ID,
          provider: physicianId,
          serviced_at: new Date().toISOString()
      }),
      processData: false,
      success: opts.successCb,
      error: opts.errorCb
    })
  }
}
